import {getGrpcConfig, getHostConfigByHostname_UNSAFE} from '@aboutyou/config';
import {createTranslator} from './createTranslator';
import {generateTranslations} from './generateTranslations';

/**
 * This is helper function for using translation outside a react function.
 * This is useful for e2e and some server translations happening outside react context.
 * NOTE: This is never expected to be used inside a react component
 */
export const translateGlobal = async (hostname: string) => {
  // eslint-disable-next-line no-restricted-syntax
  const config = getHostConfigByHostname_UNSAFE(hostname);
  let rawMessages = {};

  if (config != null) {
    const grpcConfig = getGrpcConfig(config.locale, config.device);
    rawMessages =
      (await generateTranslations({hostConfig: config, grpcConfig})) ?? {};
  }
  const t = createTranslator(rawMessages);
  return t;
};
